import type { PrimarySurface } from '@aztec-realms/shared-types';

/** Original imagegen objects; labels and interaction remain accessible DOM, never baked text. */
export const navigationArtManifest: Record<PrimarySurface, { id: string; url: string }> = {
  home: {
    id: 'nav-home-render-v1',
    url: new URL('../assets/nav-home-render-v1.png', import.meta.url).href,
  },
  explore: {
    id: 'nav-explore-render-v1',
    url: new URL('../assets/nav-explore-render-v1.png', import.meta.url).href,
  },
  decode: {
    id: 'nav-decode-render-v1',
    url: new URL('../assets/nav-decode-render-v1.png', import.meta.url).href,
  },
  codex: {
    id: 'nav-codex-render-v1',
    url: new URL('../assets/nav-codex-render-v1.png', import.meta.url).href,
  },
  tribe: {
    id: 'nav-tribe-render-v1',
    url: new URL('../assets/nav-tribe-render-v1.png', import.meta.url).href,
  },
};
